<script setup lang="ts">
import type { LinkType } from "@/types";

type PropsType = {
  link: LinkType;
};

const props = defineProps<PropsType>();
const link = toRef(() => props.link);

const getAbsolutePath = (path: string | undefined | object) => {
  // Return home if path is undefined or null
  if (!path) return "/";
  
  // If path is an object, convert to string representation of its ID or return home
  if (typeof path === 'object') {
    // @ts-ignore
    return path.id ? `/${path.id}` : "/";
  }
  
  // Now we know path is a string, proceed with normal string operations
  const pathStr = String(path); // Extra safety conversion
  
  // If URL starts with http/https, treat as external link
  if (pathStr.startsWith("http://") || pathStr.startsWith("https://")) return pathStr;
  // If path already starts with /, return as is
  if (pathStr.startsWith("/")) return pathStr;
  // Otherwise, add / prefix
  return `/${pathStr}`;
};
</script>

<template>
  <NuxtLink
    v-if="link?.type === 'page'"
    :to="getAbsolutePath(link?.page?.slug)"
  >
    <slot />
  </NuxtLink>
  <a
    v-else-if="
      link.type === 'url' &&
      link?.url &&
      (typeof link.url === 'string' && (link.url.startsWith('http://') || link.url.startsWith('https://')))
    "
    :href="typeof link.url === 'string' ? link.url : '#'"
    :target="link.target"
    rel="noopener noreferrer"
  >
    <slot />
  </a>
  <NuxtLink
    v-else-if="link.type === 'url' && link?.url"
    :to="getAbsolutePath(link?.url)"
  >
    <slot />
  </NuxtLink>
</template>
